export const messages = {
  en: {
    viewMenuGroupInfo: {
      title: 'Menu Group Information',
      selectMenuGroup: 'Select Menu Group',
      addMenuGroup: 'Add Menu Group',
      groupName: 'Group Name',
      label: 'Label',
      seq: 'Sequence',
      description: 'Description'
    }
  },
  zh: {
    viewMenuGroupInfo: {
      title: '菜单组信息',
      selectMenuGroup: '选择菜单组',
      addMenuGroup: '添加菜单组',
      groupName: '组名称',
      label: '标签',
      seq: '序列',
      description: '描述'
    }
  }
}